# Returns the index of the first index that a set of arrays differs at
#
# For example:
#
# countUntil([1,2,3], [1,2]) -> 2
# countUntil(['a', 'b', 'c'], ['a'], ['a', 'b']) -> 0
module.exports = (arrays..., predicate) ->
  [first, rest...] = arrays

  if !first?
    return 0

  if rest.length > 0
    for value, index in first
      for other in rest
        if other.length <= index || !predicate(value, other[index])
          return index

  return first.length



// WEBPACK FOOTER //
// ./app/scripts/lib/util/array/count-while.coffee